import { render, staticRenderFns } from "./banner2.vue?vue&type=template&id=5ad92bc8&scoped=true"
import script from "./banner2.vue?vue&type=script&lang=js"
export * from "./banner2.vue?vue&type=script&lang=js"
import style0 from "./banner2.vue?vue&type=style&index=0&id=5ad92bc8&prod&lang=scss&scoped=true"
import style1 from "./banner2.vue?vue&type=style&index=1&id=5ad92bc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad92bc8",
  null
  
)

export default component.exports